(function(algolia) {
  'use strict';
  //var aa = algolia.externals.aa;

  var enabled = algolia.config.analytics_enabled;
  if(!enabled) return;

  /*aa.init({
    appId: algolia.config.app_id,
    apiKey: algolia.config.search_api_key,
  });*/

  window.aa('init', {
    appId: algolia.config.app_id,
    apiKey: algolia.config.search_api_key,
  });


  // Function to generate a random string
  function generateRandomString() {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var length = 25;
    var randomString = '';

    for(var i = 0; i < length; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    return randomString;

  }

  // Function to retrieve the value of a cookie by name
  function getCookieValue(cookieName) {
    var cookies = document.cookie.split(';');
    for(var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if(cookie.startsWith(cookieName + '=')) return cookie.substring(cookieName.length + 1, cookie.length);

    }

    return '';

  }

  let mySessionID = getCookieValue('mySessionID');

  // Check if the mySessionID cookie already exists
  if (mySessionID === '') {
    // Set the mySessionID cookie only if it doesn't exist
    mySessionID = generateRandomString();
    document.cookie = `mySessionID=${mySessionID}; path=/`;

  }

  // Uncomment the following line and replace `yourUniqueUserToken` with a unique userToken to link events to a user.
  window.aa('setUserToken', mySessionID);
  //insightsClient('setUserToken', mySessionID);
    
  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function(data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      // Changing the event to 'convert' from 'click'
      conversionData.eventName = 'convert';
      // Removing the `positions` property
      delete conversionData.positions;

      // Add the current products data to local storage
      previousClickItems.push(conversionData)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));

      console.log('saveForConversionRating set');

    } catch (error) {
      console.log('saveForConversionRating Error');
      // No need to do anything in this scenario
    }
  };

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion() {
    const localStorageKey = 'algolia_analytics_clicked_objects';
    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey);
      console.log('conversion try');
      console.log(previousClickItemsString);
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString)
        previousClickItems.forEach((data) => {
          //aa('convertedObjectIDsAfterSearch', data);
          window.aa('convertedObjectIDsAfterSearch', data);
          
        })
      }
    } catch (error) {
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  function registrerView(variantIdArray) {

    aa('getUserToken', null, (err, userToken) => {
      if (err) {
        console.error(err);
        return;
      }
      token = userToken;
    });

    window.aa('viewedObjectIDs', {
      userToken: token, // required for Node.js
      index: algolia.config.index_prefix + 'products', // 'lampemagasinet_products',
      eventName: 'view',
      objectIDs: variantIdArray
    });

  }

  document.querySelectorAll('.product .product-form .form input[name="id"]').forEach( $variantIdInput => {
    registrerView([$variantIdInput.value]);
    console.log([$variantIdInput.value]);
  });

  // Track a conversion event when clicking the 'add to cart' button.
  // Change the query selector to be the correct one for your theme.
  const addToCartBtn = document.querySelector('.product-form__submit')
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      console.log('non quick add start');
      trackConversion();
      console.log('non quick add click');
    })
  }

  const addToCartBtns = document.querySelectorAll('.quick-add__submit')
  if(addToCartBtns) {
    addToCartBtns.forEach( $btn => {
      $btn.addEventListener('click', function (e) {
        trackConversion();
        console.log('quick add click')
      });
    });
  }

})(window.algoliaShopify);